import React from "react";
import { Button } from "./ui/button";
import { useAuth } from "../../ScrapFlow/context/AuthContext";
import { Mail, Phone } from "lucide-react";

export default function DeletedAccountLanding() {
  const supportEmail = "afdani.627@gmail.com";
  const supportPhone = "+91 9945272441";
  const { setShowDeletedAccount } = useAuth();

  const handleGoHome = () => {
    try {
      localStorage.removeItem("deletedAccount");
      setShowDeletedAccount(false);
      window.location.href = "/";
    } catch (e) {
      // ignore
    }
  };

  return (
    <div className="h-screen overflow-hidden bg-slate-50 px-4 pt-[calc(1rem+env(safe-area-inset-top))] pb-[calc(1rem+env(safe-area-inset-bottom))] sm:px-4">
      <div className="mx-auto flex h-full w-full max-w-[520px] flex-col gap-3">
        <div className="flex flex-col items-center gap-1.5 text-center">
          <p className="text-lg font-semibold tracking-tight text-slate-950">AFDANI</p>
          <p className="text-[11px] text-slate-500">Smart Inventory Marketplace</p>
        </div>

        <img
          src="/DeletedAccountBanner.png"
          alt="Deleted account banner"
          className="w-full rounded-[28px] h-auto max-h-[550px] object-contain"
        />

        <div className="flex flex-col gap-2">
          <div className="w-full rounded-[26px] bg-white p-3 shadow-sm shadow-slate-200">
            <div className="text-center">
              <p className="text-sm font-semibold text-slate-950">Need Help?</p>
              <p className="mt-1 text-xs leading-5 text-slate-500">If you have any questions, feel free to contact our support team.</p>
            </div>
            <div className="mt-3 flex items-center justify-center gap-2">
              <a
                href={`mailto:${supportEmail}?subject=Account%20Help%20-%20Deleted%20Account`}
                className="flex-1 flex items-center justify-center gap-2 rounded-2xl bg-slate-100 px-2.5 py-2 text-sm font-semibold text-slate-950 transition hover:bg-slate-200"
              >
                <Mail className="h-4 w-4 text-slate-700" />
                <span className="truncate">{supportEmail}</span>
              </a>
              <a
                href={`tel:${supportPhone}`}
                className="flex-1 flex items-center justify-center gap-2 rounded-2xl bg-slate-100 px-2.5 py-2 text-sm font-semibold text-slate-950 transition hover:bg-slate-200"
              >
                <Phone className="h-4 w-4 text-slate-700" />
                <span className="truncate">{supportPhone}</span>
              </a>
            </div>
          </div>

          <Button
            onClick={handleGoHome}
            className="w-full rounded-[28px] bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-blue-500/20 hover:bg-blue-700"
          >
            Go to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
